import Messagebar from './Messagebar';
import styled from '@emotion/styled';
import { RiskReductionSvg } from 'images/shared';

export const looptijdExplanation =
  `Door het aflossen op een hypotheek daalt de restschuld en gelden voor de 
lening veelal steeds lagere risicoklassen. Het hangt echter van de 
voorwaarden van de geldverstrekker af of deze de daarbij behorende rentedaling doorvoert. 
Geldverstrekkers met het %-icoontje doen dat automatisch zodra een volgende risicoklasse wordt bereikt. 
Dat is gunstig voor de zogenaamde looptijdrente: de gemiddelde rente die wordt 
betaald over de gehele looptijd van een hypothecaire lening. 
Vergelijking op basis van looptijdrente geeft dus een zuiverder beeld van de 
totale rentelasten op de lange termijn dan alleen een vergelijking 
op basis van het rentepercentage bij de start.`

const SvgContainer = styled.div(({ theme: { highlightColor } }) => ({
  height: 16,
  width: 16,
  display: 'inline-block',
  margin: '0 4px',
  verticalAlign: 'middle',
  svg: {
    width: 16,
    height: 16,
    display: 'block',
    fill: highlightColor,
  },
}));

const Container = styled.div({
  [`@media (max-width: 548px)`]: { width: '20em' },
});

export const LooptijdrenteMessagebar = ({ ...props }) => {
  return (
    <Messagebar modalText={looptijdExplanation} modalTitle="Looptijdrente" {...props}>
      <Container>
        Geldverstrekkers van producten met
        <SvgContainer>
          <RiskReductionSvg />
        </SvgContainer>
        passen automatische rentedaling toe
      </Container>
    </Messagebar>
  );
};

export default LooptijdrenteMessagebar;
